import { render, staticRenderFns } from "./TraxUiDropzone.vue?vue&type=template&id=3da7b7d8&scoped=true"
import script from "./TraxUiDropzone.vue?vue&type=script&lang=js"
export * from "./TraxUiDropzone.vue?vue&type=script&lang=js"
import style0 from "./TraxUiDropzone.vue?vue&type=style&index=0&id=3da7b7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7b7d8",
  null
  
)

export default component.exports